import { render, staticRenderFns } from "./Module63Item.vue?vue&type=template&id=620324a4&scoped=true&"
import script from "./Module63Item.vue?vue&type=script&lang=js&"
export * from "./Module63Item.vue?vue&type=script&lang=js&"
import style0 from "./Module63Item.vue?vue&type=style&index=0&id=620324a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620324a4",
  null
  
)

export default component.exports